<template>
  <div v-if="inDrawer" class="flex flex-row gap-4 mb-16">
    <div
      v-if="!!inDrawerParentPlanLabels.length && !existingCustomer"
      class="flex flex-row gap-4"
    >
      <AppLabel
        v-for="label in inDrawerParentPlanLabels"
        :key="label.Text + label.Color"
        :color="label.Color"
        :text="label.Text"
      />
    </div>

    <div v-if="!!inDrawerFamilyPlanLabels.length" class="flex flex-row gap-4">
      <AppLabel
        v-for="label in inDrawerFamilyPlanLabels"
        :key="label.Text + label.Color"
        :color="label.Color"
        :text="label.Text"
      />
    </div>
  </div>
  <div
    v-else
    class="flex flex-row gap-4"
    :class="{
      'mb-16':
        !!(outsideDrawerParentPlanDiscounts.length && !existingCustomer) ||
        (!!outsideDrawerFamilyPlanDiscounts.length && existingCustomer),
    }"
  >
    <div
      v-if="!!outsideDrawerParentPlanDiscounts.length && !existingCustomer"
      class="flex flex-row gap-4"
    >
      <AppLabel
        v-for="label in outsideDrawerParentPlanDiscounts"
        :key="label.Text + label.Color"
        :color="label.Color"
        :text="label.Text"
      />
    </div>

    <div
      v-if="!!outsideDrawerFamilyPlanDiscounts.length && existingCustomer"
      class="flex flex-row gap-4"
    >
      <AppLabel
        v-for="label in outsideDrawerFamilyPlanDiscounts"
        :key="label.Text + label.Color"
        :color="label.Color"
        :text="label.Text"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { general_mapDiscountsToLabels } from '~/utils/general/label';
const familyStore = useFamilyStore();

interface Props {
  existingCustomer: boolean;
  inDrawer: boolean;
}
defineProps<Props>();

const MAX_AMOUNT_OF_LABELS = 2;

const inDrawerParentPlanLabels = computed(() => {
  const discounts =
    familyStore.selectedParentPlanBundlePrice?.Discounts?.filter(
      (discount) => discount.DiscountType === 'Tholbox',
    ).slice(0, MAX_AMOUNT_OF_LABELS) ?? [];

  return general_mapDiscountsToLabels(discounts);
});

const inDrawerFamilyPlanLabels = computed(() => {
  const discounts =
    familyStore.selectedFamilyPlanBundlePrice?.Discounts?.filter(
      (discount) => discount.DiscountType === 'Tholbox',
    ).slice(0, MAX_AMOUNT_OF_LABELS) ?? [];

  return general_mapDiscountsToLabels(discounts);
});

const outsideDrawerParentPlanDiscounts = computed(() => {
  const discounts = familyStore.ParentPlansDiscounts?.slice(
    0,
    MAX_AMOUNT_OF_LABELS,
  );

  return general_mapDiscountsToLabels(discounts);
});

const outsideDrawerFamilyPlanDiscounts = computed(() => {
  const discounts = familyStore.FamilyPlansDiscounts?.slice(
    0,
    MAX_AMOUNT_OF_LABELS,
  );

  return general_mapDiscountsToLabels(discounts);
});
</script>

<style scoped></style>
